import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";

export default defineComponent ({
    name: "CompletePage",
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        visitDetails: {
            type: Object,
            required: true
        },
        visitCodeQr: {
            type: Object,
            required: false
        }
    },
    setup() {
        const portal = usePortalStore()

        return {
            portal
        };
    }
});